module.exports = __webpack_public_path__ + "media/images/pic/labels/materials/doki-doki-3-f88eca4e3690d166723263ee69a561b3.jpg";